export const useScreenWidth = () => {
  return {
    isMobile: window.innerWidth < 600,
    isTablet: window.innerWidth >= 600 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
  };
};
